module.exports = __webpack_public_path__ + "img/f.a00fd29d.jpg";